import { SeverityPills } from '@shape/lighthouse-components';

type RiskStatusProps = {
  risk: string;
};

export const alarmHistoryStatusMap: AlarmHistoryStatusMap = {
  HIGH: 4,
  MEDIUM: 3,
  LOW: 2,
};

const RiskStatus: React.FC<RiskStatusProps> = ({ risk }: RiskStatusProps) => {
  return (
    <span className="status-wrapper">
      <SeverityPills severity={alarmHistoryStatusMap[risk]} totalPills={4} />
    </span>
  );
};

export default RiskStatus;
